import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { LoginRoutingModule } from './login-routing.module';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SsoComponent } from './sso/sso.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

import { WebStorageStateStore, Log } from 'oidc-client-ts';
import { OAuthModule } from 'angular-oauth2-oidc';
import { LogoutSsoComponent } from './logout-sso/logout-sso.component';
import { EndSessionComponent } from './end-session/end-session.component';
import { ResetLoginComponent } from './reset-login/reset-login.component';
import { TimeSyncComponent } from './time-sync/time-sync.component';
import { IdleTimeoutComponent } from './idle-timeout/idle-timeout.component';
import { SignoutMessageComponent } from './signout-message/signout-message.component';
import { CarouselModule } from '@projects/shared/src/app/modules/carousel/carousel';
import { SwiperLoginComponent } from './swiper/swiper.login.component';
import { CodeVerificationComponent } from './code-verification/code-verification.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { SigninCallbackComponent } from './signin-callback/signin-callback.component';
import { SignoutCallbackComponent } from './signout-callback/signout-callback.component';
import { PostLogoutComponent } from './post-logout/post-logout.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { LoginComponent } from './login.component';
import { WithAuthComponent } from '../container/with-auth/with-auth.component';
import { WithNoAuthComponent } from '../container/with-no-auth/with-no-auth.component';
import { NotFound404Component } from './404/404.component';
import { OopsComponent } from './oops/oops.component';
import { SharedModule } from '@shared/shared.module';
import { PreLogoutComponent } from './pre-logout/pre-logout.component';
import { RecoveryCodeComponent } from './recovery-code/recovery-code.component';
import { RecoveryCodeVerificationComponent } from './recovery-code-verification/recovery-code-verification.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { SMSVerificationComponent } from './sms-verification/sms-verification.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { MFANotAllowComponent } from './mfa-not-allow/mfa-not-allow.component';

export interface State {
  router: RouterReducerState;
}

export const rootStore: ActionReducerMap<State> = {
  router: routerReducer,
};

export function getWebStorageStateStore() {
  return new WebStorageStateStore({ store: window.localStorage });
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    FormsModule,
    OAuthModule.forRoot(),
    CarouselModule,
    SharedModule.forRoot(),
    StoreModule.forRoot(rootStore),
    EffectsModule.forRoot([]),
  ],
  declarations: [
    OopsComponent,
    NotFound404Component,
    UnauthorizedComponent,
    SwiperLoginComponent,
    LoginComponent,
    SsoComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    LogoutSsoComponent,
    EndSessionComponent,
    ResetLoginComponent,
    WithNoAuthComponent,
    WithAuthComponent,
    TimeSyncComponent,
    IdleTimeoutComponent,
    SignoutMessageComponent,
    CodeVerificationComponent,
    SetPasswordComponent,
    SigninCallbackComponent,
    SignoutCallbackComponent,
    PostLogoutComponent,
    PreLogoutComponent,
    RecoveryCodeComponent,
    RecoveryCodeVerificationComponent,
    EmailVerificationComponent,
    SMSVerificationComponent,
    ForbiddenComponent,
    MFANotAllowComponent,
  ],
})
export class LoginModule {}
